import React from "react";
import ImportModal from "components/modals/import-modal/import-modal";
import { ActionButton, Modal, Text } from "components/commons";
import locale from "localization";
import { useCallback } from "react";
import styles from "./import-unique-voucher-modal.module.scss";

const ImportUniqueVoucherModal = ({ refresh, resultModal, importRequest, ...importModal }) => {
  const validateFile = async ({ file }) => {
    const isEmpty = !file || file.size === 0;
    return { isEmpty, file };
  };

  const showErrorModal = useCallback(
    ({ error = {} }) => {
      importModal.close();
      const { data = {} } = error;
      const { invalidRowList = [] } = data;
      let existingRows = [];
      let otherFailingRows = [];
      for (let i = 0; i < invalidRowList.length; i++) {
        let row = invalidRowList[i];
        if (row.code === 409) {
          existingRows.push(row.row);
        } else {
          otherFailingRows.push(row.row);
        }
      }
      const backItem = {
        text: locale.back || "Back",
        onClick: () => {
          resultModal.close();
          importModal.show();
        },
        primary: true,
      };
      resultModal.show({
        title: locale.importFailedNew,
        content: <ErrorImport existingRows={existingRows} otherFailingRows={otherFailingRows} />,
        items: [backItem],
      });
    },
    [resultModal, importModal],
  );

  return (
    <div>
      <Modal
        {...resultModal}
        close={() => {
          resultModal.close();
          refresh();
        }}
      >
        {resultModal.content}
        <ActionButton
          right={!resultModal.isSuccess}
          center={true}
          items={
            resultModal.items ||
            (resultModal.isSuccess
              ? [
                  {
                    text: locale.gotIt,
                    onClick: () => {
                      resultModal.close();
                      refresh();
                    },
                    primary: true,
                  },
                ]
              : [
                  {
                    text: locale.back || "Back",
                    onClick: () => {
                      resultModal.close();
                      importModal.show();
                    },
                    primary: true,
                  },
                ])
          }
        />
      </Modal>
      <ImportModal
        {...importModal}
        loading={importRequest.loading}
        title={locale.importAndMassCreateVoucherCampaignViaCsv}
        children={[
          <Text
            key="a"
            label
            className={`${styles.label} ${styles.messageText} ${styles.messageSpacing}`}
          >
            {locale.followTheFollowingColumnOrderAndLeaveRow1AsColumnHeaders}
          </Text>,
          <Text
            key="b"
            label
            className={`${styles.labelMessage} ${styles.messageText} ${styles.messageBottom}`}
          >
            {locale.downloadA}{" "}
            <a
              href="https://locq-assets.s3.ap-southeast-1.amazonaws.com/voucher-campaign-import-template.csv"
              download="voucher-campaign-import-template.csv"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.sampleTemplate}
            >
              <strong>{locale.sampleTemplate}</strong>
            </a>{" "}
            {locale.toSeeAnExampleOfTheFormatRequired}
          </Text>,
        ]}
        onSubmit={async (file) => {
          const fileValidation = await validateFile(file);

          if (fileValidation.isEmpty) {
            importModal.close();
            resultModal.show({
              title: locale.importFailedNew,
              content: <ErrorImport otherError={[locale.emptyCsv]} />,
              items: [
                {
                  text: locale.back,
                  onClick: () => {
                    resultModal.close();
                    importModal.show();
                  },
                  primary: true,
                },
              ],
            });
            return;
          }

          try {
            const formData = new FormData();
            formData.append("data", fileValidation.file);

            const res = await importRequest.request({
              data: formData,
            });

            const isSuccess = !res?.data?.invalidRowList?.length && !res?.data?.errorCode;

            if (isSuccess) {
              resultModal.show({
                title: locale.importSuccessful,
                isSuccess: true,
                content: (
                  <div className={styles.successContent}>
                    <Text>{locale.voucherHasBeenSuccessfullyImported}</Text>
                  </div>
                ),
              });
              refresh();
            } else {
              showErrorModal({
                error: res,
              });
            }
            importModal.close();
          } catch (e) {
            showErrorModal({
              error: e,
            });
          }
        }}
      />
    </div>
  );
};

const ErrorImport = ({ existingRows = [], otherFailingRows = [] }) => {
  const existingRowsString = Array.isArray(existingRows)
    ? existingRows.join(", ")
    : String(existingRows);
  const otherFailingRowsString = Array.isArray(otherFailingRows)
    ? otherFailingRows.join(", ")
    : String(otherFailingRows);

  return (
    <div className={styles.vcimpContainer}>
      {existingRows.length > 0 && (
        <>
          <div className={styles.vcimpMessage}>
            <Text>{locale.youHaveRowsWithAlreadyExistingPrefix}</Text>
          </div>
          <div className={styles.vcimpRows}>
            <b>Rows no. {existingRowsString}</b>
          </div>
        </>
      )}
      <br />
      {otherFailingRows.length > 0 && (
        <>
          <div className={styles.vcimpMessage}>
            <Text>{locale.youHaveRowsWithInputErrors}</Text>
          </div>
          <div className={styles.vcimpRows}>
            <b>Rows no. {otherFailingRowsString}</b>
          </div>
        </>
      )}
    </div>
  );
};

export default ImportUniqueVoucherModal;
